import React from "react";
import * as S from "./styles";
export var LinkedIn = function LinkedIn(e) {
  return React.createElement(S.SVG, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    height: "18"
  }, e), React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M14.857.2c.31 0 .578.12.804.36.226.24.339.524.339.852v14.544c0 .328-.113.613-.34.852-.225.24-.493.36-.803.36H1.143c-.31 0-.578-.12-.804-.36-.226-.24-.339-.524-.339-.852V1.412C0 1.084.113.8.34.56.564.32.832.2 1.142.2h13.714zM2.464 14.744h2.393V6.64H2.464v8.105zm1.179-9.203c.38 0 .708-.145.982-.436.274-.29.41-.631.41-1.022 0-.392-.136-.733-.41-1.023-.274-.29-.601-.436-.982-.436s-.703.146-.964.436c-.262.29-.393.631-.393 1.023 0 .39.13.732.393 1.022.261.29.583.436.964.436zm10.071 9.203v-4.431c0-1.263-.166-2.184-.5-2.765-.452-.732-1.226-1.098-2.321-1.098-.548 0-1.036.139-1.464.416-.358.228-.62.518-.786.871h-.036V6.64H6.321v8.105H8.68V10.73c0-.632.083-1.111.25-1.44.238-.429.63-.644 1.178-.644.548 0 .905.24 1.072.72.119.303.178.783.178 1.44v3.938h2.357z"
  }));
};